if (!customElements.get('sonee-subcollections')) {
  customElements.define('sonee-subcollections', class extends HTMLElement {
    connectedCallback() {
      this.list = this.querySelector('ul');
      this.previous = this.querySelector('[data-previous]');
      this.next = this.querySelector('[data-next]');
      this.update = () => {
        const overflow = this.list.scrollWidth > this.list.clientWidth + 1;
        const canPrevious = overflow && this.list.scrollLeft > 1;
        const canNext = overflow && this.list.scrollLeft + this.list.clientWidth < this.list.scrollWidth - 1;
        this.previous.hidden = !canPrevious;
        this.next.hidden = !canNext;
        this.classList.toggle('can-scroll-previous', canPrevious);
        this.classList.toggle('can-scroll-next', canNext);
      };
      this.controller = new AbortController();
      const options = { signal: this.controller.signal };
      this.list.addEventListener('scroll', this.update, options);
      for (const [button, direction] of [[this.previous, -1], [this.next, 1]]) {
        button.addEventListener('click', () => this.list.scrollBy({
          left: direction * this.list.clientWidth * 0.8,
          behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth'
        }), options);
      }
      this.observer = new ResizeObserver(this.update);
      this.observer.observe(this.list);
      for (const item of this.list.children) this.observer.observe(item);
      const selected = this.list.querySelector('[aria-current="page"]');
      if (selected) {
        const selectedLeft = selected.getBoundingClientRect().left - this.list.getBoundingClientRect().left + this.list.scrollLeft;
        this.list.scrollLeft = Math.max(0, selectedLeft - (this.list.clientWidth - selected.clientWidth) / 2);
      }
      this.update();
    }
    disconnectedCallback() {
      this.controller.abort();
      this.observer.disconnect();
    }
  });
}
